import { render, staticRenderFns } from "./DeleteSupplierModal.vue?vue&type=template&id=ffd687d0&scoped=true"
import script from "./DeleteSupplierModal.vue?vue&type=script&lang=js"
export * from "./DeleteSupplierModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd687d0",
  null
  
)

export default component.exports